import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedReduxCalendar } from '../../ducks/calendarActions';

const SubCalendarDiv = styled('div')`
  cursor: pointer;
  margin-bottom: 10px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: #444444;
  background-color: ${({ isSelected }) => (isSelected ? '#f0f0f0' : 'transparent')};
`;

const CollapsedSubCalendar = ({
  subCalendar,
  parentCalendarIndex,
  isSelected,
}) => {
  const dispatch = useDispatch();
  const parentCalendars = useSelector((state) => state.calendar.data.parentCalendars);

  return (
    <SubCalendarDiv
      onClick={(e) => {
        e.stopPropagation();
        // Set parentCalendarInfo along with the subcalendar selection
        const parentCalendar = parentCalendars[parentCalendarIndex];
        dispatch(setSelectedReduxCalendar({
          ...subCalendar,
          parentCalendarInfo: {
            id: parentCalendar.id,
            name: parentCalendar.name,
          },
        }));
      }}
      data-calendar-id={subCalendar.id}
      isSelected={isSelected}
    >
      {subCalendar.name}
    </SubCalendarDiv>
  );
};

CollapsedSubCalendar.propTypes = {
  subCalendar: PropTypes.instanceOf(Object).isRequired,
  parentCalendarIndex: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
};

CollapsedSubCalendar.defaultProps = {
  isSelected: false,
};

export default CollapsedSubCalendar;
